<template>
  <div style="min-height:50vh">
    <div class="w1000 ma pt40">
      <div class="sv_l fl">
        <div 
          class="sv_nav mb10 f16 l36 fyh pl25"
          :style="
            leftIndex == 2
              ? 'background: url(/img/sv_navjt.png) no-repeat 130px 16px #EAEAEA !important;'
              : ''
          " 
          @click="ChangeleftIndex(2)"
        >
          <a
            class="go-next"
            href="javascript:;"
            data-target="_self" 
            data-url="AbouUs.aspx"
          >
            公司简介</a
          >
        </div>
        <div
          class="sv_nav mb10 f16 l36 fyh pl25"
          @click="ChangeleftIndex(0)"
          :style="
            leftIndex == 0
              ? 'background: url(/img/sv_navjt.png) no-repeat 130px 16px #EAEAEA !important;'
              : ''
          "
        >
          <a
            class="go-next"
            href="javascript:;"
            data-target="_self"
            data-url="News.aspx"
            >新闻公告</a
          >
        </div>
        <div
          class="sv_nav mb10 f16 l36 fyh pl25"
          @click="ChangeleftIndex(1)"
          :style="
            leftIndex == 1
              ? 'background: url(/img/sv_navjt.png) no-repeat 130px 16px #EAEAEA !important;'
              : ''
          "
        >
          <a
            class="go-next"
            href="javascript:;"
            data-target="_self"
            data-url="CompanyNews.aspx"
            >公司动态</a
          >
        </div>
      </div>
      <div class="sv_r fr">
        <!-- //公司简介 -->
        <div v-html="gongsi" v-if="leftIndex == 2"></div>
        <div  v-if="leftIndex != 2 && showDetail">
            <p class="f28 wb l28 h50 fyh">
                <span id="ContentPlaceHolder1_lbl_title">{{detail.mTitle}}</span></p>
                <div class="f12 h28 mt20 bb1d">
                <p class="fl">
                    {{detail.mAuthor}} | <a class="go-next" href="javascript:;" data-target="_self" data-url="News.aspx">{{detail.mType==0?'新闻公告':'公司动态'}}</a>   
                    <!-- JiaThis Button END -->
                </p>
                <p class="fr">
                    <span id="ContentPlaceHolder1_lbltime">{{detail.mDate}}</span></p>
            </div>
            <div v-html="detail.mContent"></div>
        </div>
        <!-- //列表 -->
        <div v-if="leftIndex != 2 && !showDetail">
          <div id="newsserch" v-if="leftIndex != 2 ">
            <div class="topbox">
              <!-- <div class="inputbox">
                <input
                  name="ctl00$ContentPlaceHolder1$txt_key"
                  type="text"
                  id="ContentPlaceHolder1_txt_key"
                  onkeypress="serch();"
                />
              </div> -->
              <div class="btnbox">
                <input
                  type="button"
                  name="ctl00$ContentPlaceHolder1$btnSerch"
                  value=""
                  onclick="javascript:__doPostBack('ctl00$ContentPlaceHolder1$btnSerch','')"
                  id="ContentPlaceHolder1_btnSerch"
                  class="btn"
                />
              </div>
            </div>
          </div>

          <div
            class="news pt15 pb15 bb1d f12"
            v-for="(item, index) in list"
            :key="index"
          >
            <p class="f20 h28">
              <span class="fl fyh wb"
            
                ><a
                
                  class="go-next"
               @click="showDeatil(item)"
                >
                  {{ item.mTitle }}</a
                ></span
              >
              <span class="fr f12"
                >{{ item.mAuthor }}&nbsp;&nbsp; {{ item.mDate }}</span
              >
            </p>
            <span  style="width:100%; display:inline-block;overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">
 {{ item.mSubtitle
            }}

            </span>
           <span class="wblue"
              ><a
                class="go-next"
@click="showDeatil(item)"
                >[详情]</a
              >
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="cl"></div>
  </div>
</template>
<style scoped src="../../public/css/common1.css">
</style>
<style scoped src="../../public/css/rwx.css">
</style>
<style scoped src="../../public/css/base01.css">
</style>
<script>
import { getGonggaoList } from "@/api/index";
export default {
  name: "aaaa",
  data() {
    return {
      list: [],
      leftIndex: 2,
            listQuery: {
        page: 1,
        limit: 20,
        type: 0,
      },
      gongsi: "",
      showDetail:false,
      detail:''
    };
  },
  created() {
    //默认值
    this.leftIndex =
      this.$route.query.id == undefined ? 2 : this.$route.query.id;
    this.getInfoByIndex(this.leftIndex);
  },
  methods: {
        GetUrlParam(paraName) {
    　　　　var url = window.location.toString();
    　　　　var arrObj = url.split("?");
 
    　　　　if (arrObj.length > 1) {
    　　　　　　var arrPara = arrObj[1].split("&");
    　　　　　　var arr;
 
    　　　　　　for (var i = 0; i < arrPara.length; i++) {
    　　　　　　　　arr = arrPara[i].split("=");
 
    　　　　　　　　if (arr != null && arr[0] == paraName) {
    　　　　　　　　　　return arr[1];
    　　　　　　　　}
    　　　　　　}
    　　　　　　return "";
    　　　　}
    　　　　else {
    　　　　　　return "";
    　　　　}
    　　},
      showDeatil(item){
this.detail=item;
this.showDetail=true
      },
    ChangeleftIndex(index) {
      this.leftIndex = index;
      this.showDetail=false;
      this.getInfoByIndex(this.leftIndex);
    },
    getInfoByIndex(index) {
        this.listQuery.type=index
        this.listQuery.qiyeId=this.GetUrlParam("qiyeId")
      getGonggaoList(this.listQuery).then((response) => {
        if (this.leftIndex == 2) {
          this.gongsi = response.data.mContent;
        } else {
          this.list = response.data;
        }
      });
    },
  },
};
</script>